<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogStatus" max-width="300" persistent>

      <v-card align-center>
        <v-card-text>
          <v-card-title class="headline text-xs-center" mx-4>
            <div style="width:100%;text-align:center">
              <h5>Dejesa excluir o registro?</h5>
            </div>
          </v-card-title>
         <!--  <v-icon>report_problem</v-icon> -->
          <v-card-text class="text-xs-center subtitle-2 pt-0"  style="color:brown !important">
            A ação será irreversivél!
          </v-card-text>

          <v-card-actions>
            <div style="width:100%;text-align:center">
              <v-btn color="green darken-1" class="mx-2 white--text" @click="remove();">
                Sim
              </v-btn>
              <v-btn color="green darken-1" class="mx-2 white--text" @click="closeDialog">
                Não
              </v-btn>
            </div>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    data() {
      return {
        dialogStatus: false,
        item: null
      }
    },
    methods: {

      openDialog(item) {
        this.item = item
        this.dialogStatus = true;
      },
      closeDialog() {
        this.item = {};
        this.dialogStatus = false
      },
      remove() {
        this.$emit('deleteItem', this.item)
        this.closeDialog()
      }

    },
  }

</script>
<style >
  
</style>



// WEBPACK FOOTER //
// src/components/AlertDelete.vue